//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "código",
        value: "name",
    },
    /*{
        text: "modulo",
        value: "guard_name",
    },*/
    {
        text: "fecha de creación",
        value: "created_at",
        format: "datetime",
    },
]